import { Button } from '@advanza/ui'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import BaseModal, {
    BaseModalFooter,
    BaseModalHeader,
    BaseModalMainContent,
} from '@trustoo/components/modal/BaseModal'

interface DeactivateSubscriptionModalProps {
    onConfirm: () => void
    onCancel: () => void
}

const DeactivateSubscriptionModal = NiceModal.create(
    ({ onConfirm, onCancel }: DeactivateSubscriptionModalProps) => {
        const modal = useModal()

        const onClose = () => {
            modal.resolve()
            modal.hide()
            onCancel()
        }

        return (
            <BaseModal onClose={onClose}>
                <BaseModalHeader>
                    <h2 className="text-display-xs font-bold">Deactivate Subscription</h2>
                </BaseModalHeader>
                <BaseModalMainContent>
                    <p>
                        Are you sure you want to deactivate this subscription? Niels to fill in
                        rest.
                    </p>
                </BaseModalMainContent>
                <BaseModalFooter>
                    <div className="row justify-end gap-2">
                        <Button appearance="outlined_primary" onClick={onClose}>
                            Cancel
                        </Button>
                        <Button
                            appearance="primary"
                            onClick={() => {
                                onConfirm()
                                modal.resolve()
                                modal.hide()
                            }}>
                            Deactivate
                        </Button>
                    </div>
                </BaseModalFooter>
            </BaseModal>
        )
    },
)

export default DeactivateSubscriptionModal
